import LogicalCascadedSelect from '../cascaded_select.js';
import LogicalCheckBox from '../check_box.js';
import LogicalDateTime from '../date_time.js';
import LogicalDetail from '../detail.js';
import LogicalFile from '../file.js';
import LogicalInteger from '../integer.js';
import LogicalLocation from '../location.js';
import LogicalMember from '../member.js';
import LogicalOrganization from '../organization.js';
import LogicalRadioButton from '../radio_button.js';
import LogicalRating from '../rating.js';
import LogicalTextField from '../text_field.js';
import LogicalTextArea from '../text_area.js';
import LogicalCalculation from '../calculation.js';

import LogicFieldListMixin from './mixin.js';

const LOGICAL_FIELDS = {
  LogicalCascadedSelect,
  LogicalCheckBox,
  LogicalDateTime,
  LogicalDetail,
  LogicalFile,
  LogicalInteger,
  LogicalLocation,
  LogicalMember,
  LogicalOrganization,
  LogicalRadioButton,
  LogicalRating,
  LogicalTextField,
  LogicalTextArea,
  LogicalCalculation
};

const LogicFieldListFieldable = Vue.extend({
  mixins: [LogicFieldListMixin],

  props: {
    logicalFields: {
      type: Object,
      default: function() {
        return LOGICAL_FIELDS;
      }
    }
  }
});

export default LogicFieldListFieldable;
